<template>
  <!-- <div class="latework-wrapper pl-4 pr-8"> -->
  <!-- <div class="birthday-this-month-wrapper pl-4 pr-8"> -->
  <div class="left-bottom-wrapper pl-4 pr-8" :class="haveBgLate ? 'latework-wrapper' : 'birthday-this-month-wrapper'">
    <div class="slide-deck-wrapper px-8 py-10">
      <swiper ref="swiper" class="swiper"
        :options="swiperOption"
        @slideChange="handleIndex">
        <template v-if="haveBirthdays">
          <swiper-slide v-for="emp in dobList" :key="emp.id">
            <BirthdayCard :emp="emp" />
          </swiper-slide>
        </template>
        <swiper-slide v-else>
          <BirthdayCard :noDataMessage="noDataMessage" />
        </swiper-slide>

        <template v-if="allowLate && haveLateWork">
          <swiper-slide v-for="emp in lateList"
            :data-swiper-autoplay="(lateWorkInterval || dobConfig.autoslide_interval) * 1000"
            :key="`late-${emp.id}`">
            <LateWorkCard :emp="emp" />
          </swiper-slide>
        </template>
      </swiper>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
/* eslint-disable no-unused-vars */
import { mapGetters } from 'vuex'
import BirthdayCard from './birthday/BirthdayCard'
import LateWorkCard from './birthday/LateWorkCard'

export default {
  components: {
    BirthdayCard,
    LateWorkCard,
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  computed: {
    ...mapGetters({
      lateWork: 'lateWork',
      dobConfig: 'birthdayThisMonthConfig',
      dobList: 'birthdayThisMonthList',
    }),
    swiper() {
      return this.$refs.swiper && this.$refs.swiper.$swiper
    },
    swiperOption() {
      if(this.dobConfig && this.dobConfig.autoslide_interval) {
        const { autoslide_interval, default_transition } = this.dobConfig
        const config = {
          effect: default_transition,
          fadeEffect: {
            crossFade: true
          },
          loop: false,
          speed: 500,
          autoplay: {
            enabled: autoslide_interval > 0,
            delay: autoslide_interval * 1000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
          },
        }
        return config
      }
      return null
    },
    noDataMessage() {
      return this.dobConfig && this.dobConfig.no_data_message
    },
    haveBirthdays() {
      return this.dobList && this.dobList.length
    },
    allowLate() {
      return this.dobConfig && this.dobConfig.allow_late_emp_list
    },
    haveLateWork() {
      return this.lateWork && this.lateWork.employeeList && this.lateWork.employeeList.length
    },
    lateList() {
      return (this.lateWork && this.lateWork.employeeList) || []
    },
    lateWorkInterval() {
      return this.lateWork && this.lateWork.slide_interval
    },
    haveBgLate() {
      return (this.activeIndex >= this.dobList.length) && this.allowLate && this.haveLateWork
    }
  },
  methods: {
    handleIndex() {
      this.activeIndex = this.swiper && this.swiper.activeIndex
    }
  }
}
</script>

<style>
.birthday-this-month-wrapper .emp-avatar {
  border: .25rem solid #00a0d1;
}
</style>
